export const compareNumber = (a: number, b: number, sortOrder: 'ASC' | 'DESC' = 'ASC') => {
	if ((isNaN(a) && isNaN(b)) || a === b) {
		return 0;
	} else if (isNaN(a)) {
		return 1;
	} else if (isNaN(b)) {
		return -1;
	}

	const comparatorAsc = a < b ? -1 : 1;
	const comparatorDesc = a < b ? 1 : -1;

	return sortOrder === 'ASC' ? comparatorAsc : comparatorDesc;
};

export const sortAlphabetically = (a?: string, b?: string, order: 'ASC' | 'DESC' = 'ASC') => {
	if ((a === undefined && b === undefined) || a === b) {
		return 0;
	} else if (a === undefined) {
		return order === 'ASC' ? -1 : 1;
	} else if (b === undefined) {
		return order === 'ASC' ? 1 : -1;
	} else {
		return a.toLowerCase().localeCompare(b.toLowerCase()) * (order === 'ASC' ? 1 : -1);
	}
};
